import OrderEventsOverview from './overview'
module.exports = {
  OrderEventsOverview
}



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/orderevents/index.js